import { useMutation } from "@tanstack/react-query";

import { RestError } from "../../../../../shared/lib/exceptions";
import { ForwardInviteBody } from "../../../public/supplier-types";
import { forwardInvite } from "./supplier-registration.api";

export type ForwardInviteError = 404 | 409 | 503 | null;

// 404 → uniform invalid-link (unknown id / bad token / revoked / already-CONNECTED); 409 → self
// re-invite or duplicate-for-buyer (indistinguishable by design); anything else → 503 (generic
// retryable bucket, covers 400 DTO validation, 5xx, and no-response network failures).
const toForwardInviteError = (error: unknown): ForwardInviteError => {
  if (error instanceof RestError && (error.statusCode === 404 || error.statusCode === 409)) {
    return error.statusCode;
  }
  return error ? 503 : null;
};

export const useForwardInvite = (): {
  mutate: (body: ForwardInviteBody) => Promise<void>;
  isPending: boolean;
  error: ForwardInviteError;
} => {
  const { mutateAsync, isPending, error } = useMutation({
    meta: { silentError: true },
    mutationFn: forwardInvite,
  });

  return { mutate: mutateAsync, isPending, error: toForwardInviteError(error) };
};
